// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "marked" + "." + "9338378577894f3123a6" + ".js";
};